import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=3abf459b&scoped=true&"
import script from "./Lesson.vue?vue&type=script&lang=ts&"
export * from "./Lesson.vue?vue&type=script&lang=ts&"
import style0 from "./Lesson.vue?vue&type=style&index=0&id=3abf459b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf459b",
  null
  
)

export default component.exports